module.exports = __webpack_public_path__ + "static/parting-the-waters-4770983a865f259ab4493c1fa3fc737e.jpg";